import React from "react";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { CtaBand } from "@/pages/Home";
import { SOLUTIONS, SEGMENTS, ASSET_CLASSES } from "@/data/site";

export default function Solutions() {
  return (
    <div data-testid="solutions-page">
      <PageHero
        overline="Solutions"
        title="Institutional liquidity, engineered around your book."
        subtitle="From aggregated price construction to bespoke execution and market-making, every element of an ET Prime relationship is configured to your desk — not sold from a shelf."
      />

      {/* CORE SOLUTIONS */}
      <section className="py-24 md:py-32 relative z-10" data-testid="core-solutions">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {SOLUTIONS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.08} className="bg-[#0A0D12]">
                <div className="p-10 md:p-12 h-full hover:bg-[#11151C] transition-colors" data-testid={`solution-${i}`}>
                  <span className="font-mono text-xs text-[#737882]">0{i + 1}</span>
                  <h3 className="font-display text-2xl md:text-3xl font-light text-white mt-6">{s.title}</h3>
                  <p className="text-[#A1A5AB] mt-5 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* SEGMENTS DETAIL */}
      <section className="py-24 md:py-32 relative z-10 border-y border-white/10" data-testid="segments-detail">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <span className="overline">Tailored by client type</span>
            <h2 className="font-display text-3xl md:text-4xl font-light tracking-tight text-white mt-5 max-w-2xl">
              Solutions that speak your business context.
            </h2>
          </Reveal>
          <div className="mt-16 space-y-px bg-white/10 border border-white/10">
            {SEGMENTS.map((seg, i) => (
              <Reveal key={seg.id} delay={i * 0.05} className="bg-[#0A0D12]">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 p-10 hover:bg-[#11151C] transition-colors" data-testid={`segment-detail-${seg.id}`}>
                  <div className="md:col-span-4">
                    <span className="font-mono text-xs text-[#C8A45A]">0{i + 1}</span>
                    <h3 className="font-display text-2xl text-white mt-3">{seg.title}</h3>
                    <p className="text-[#A1A5AB] mt-2">{seg.line}</p>
                  </div>
                  <div className="md:col-span-8 md:border-l md:border-white/10 md:pl-10 flex items-center">
                    <p className="text-[#A1A5AB] leading-relaxed">{seg.detail}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ASSET COVERAGE */}
      <section className="py-24 md:py-32 relative z-10" data-testid="asset-coverage">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <span className="overline">Multi-asset coverage</span>
            <h2 className="font-display text-3xl md:text-4xl font-light tracking-tight text-white mt-5">
              Cross-margined across the markets that matter.
            </h2>
          </Reveal>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 mt-16">
            {ASSET_CLASSES.map((a, i) => (
              <Reveal key={a.name} delay={i * 0.05} className="bg-[#0A0D12] p-8 hover:bg-[#11151C] transition-colors">
                <div className="font-display text-xl text-white">{a.name}</div>
                <div className="text-sm text-[#737882] mt-2">{a.note}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
